import { useQuery } from '@tanstack/react-query'
import { api } from '@/lib/api'

/**
 * Replaces ProgramController.TLDP / ProgramController.TBIGIN, which each fetched
 * the latest active vacancy for one career id and passed it to the view as the
 * model. `Career` ids come from DTO/Enum/Career.cs.
 */
export const CAREER_INTERNSHIP = 2
export const CAREER_TLDP = 3

export interface ProgramContext {
  vacancy: { trxVacancyID: number; EndVacancy: string | null } | null
  trxVacancyID?: number
  encodedTrxVacancyID?: string
}

export function useProgramVacancy(mstCareerID: number) {
  return useQuery({
    queryKey: ['program', 'vacancy', mstCareerID],
    queryFn: () =>
      api.get<ProgramContext>(`/api/ecareer/vacancy/program-context?mstCareerID=${mstCareerID}`),
    staleTime: 5 * 60 * 1000,
  })
}
